// frontend/src/pages/vip/VIPDashboard.jsx

import React, { useEffect, useState } from "react";
import axiosClient from "../../api/axiosClient";
import NavbarVIP from "../../components/NavbarVIP";
import VIPDataView from "../../components/VIPDataView";
import VIPManualAnalytics from "../../components/VIPManualAnalytics";
import VIPPatientAnalytics from "../../components/VIPPatientAnalytics"; // ← NEW IMPORT
import {Alert, Spinner, Container, Card, Button, Row, Col,} from "react-bootstrap";
import { useNavigate } from "react-router-dom";

const VIPDashboard = ({ currentUser, page }) => {
  const [loading, setLoading] = useState(true);
  const [apiEnabled, setApiEnabled] = useState(false);
  const [manualEnabled, setManualEnabled] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  // Load VIP user settings
  useEffect(() => {
    if (!currentUser) return;

    const loadSettings = async () => {
      try {
        const res = await axiosClient.get(
          `/user-settings/${currentUser.userId}`
        );
        setApiEnabled(!!res.data.enable_api);
        setManualEnabled(!!res.data.enable_manual_reports);
      } catch (err) {
        setError("Failed to load VIP settings.");
      } finally {
        setLoading(false);
      }
    };

    loadSettings();
  }, [currentUser]);

  // Validate uploaded report type BEFORE entering module
  const validateReportType = async (expectedType) => {
    try {
      // request latest report that matches the expected type
      const res = await axiosClient.get(
        `/manual-reports/vip/${currentUser.userId}?report_type=${encodeURIComponent(expectedType)}`
      );

      if (!res.data.success) {
        // Use backend message if available (gives more accurate feedback)
        setError(res.data.message || "No manual report uploaded yet.");
        return false;
      }

      // If API success = true, report_type will match expectedType (by our SQL filter)
      return true;
    } catch (err) {
      console.error("validateReportType error:", err);
      setError("Could not validate report type.");
      return false;
    }
  };


  // Module Open Handlers
  const openMedicineModule = async () => {
    setError("");
    const ok = await validateReportType("consumption_by_medicine");
    if (ok) navigate("/vip/report/medicine");
  };

  const openPatientModule = async () => {
    setError("");
    const ok = await validateReportType("consumption_by_patient_served");
    if (ok) navigate("/vip/report/patient");
  };


  // const openMedicineModule = () => navigate("/vip/report/medicine");
  // const openPatientModule = () => navigate("/vip/report/patient"); // ← NEW FUNCTION


  // Render
  return (
    <>
      <NavbarVIP currentUser={currentUser} />

      {/* FULL WIDTH ═════════════════════════════════ */}
      <Container fluid className="mt-4 px-4">
        {/* PROFILE SECTION */}
        <Row className="align-items-center mb-3">
          <Col xs="auto">
            {currentUser?.photo ? (
              <img
                src={`http://localhost:5000${currentUser.photo}`}
                alt="profile"
                style={{ width: 84, height: 84, objectFit: "cover" }}
                className="rounded-circle border"
              />
            ) : (
              <div
                style={{
                  width: 84,
                  height: 84,
                  borderRadius: "50%",
                  background: "#eee",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
                className="border"
              >
                ?
              </div>
            )}
          </Col>

          <Col>
            <h2 className="mb-0">{currentUser?.username} Dashboard</h2>
            <small className="text-muted">
              Welcome — analytics overview
            </small>
          </Col>
        </Row>

        {loading && (
          <div className="text-center mt-3">
            <Spinner animation="border" />
            <p>Loading...</p>
          </div>
        )}

        {error && <Alert variant="danger">{error}</Alert>}

        {/* MAIN MENU ─────────────────────────────────────────────────── */}
        {!loading && page === undefined && (
          <Row className="g-4">
            <Col md={6}>
              <Card className="shadow-sm text-center p-3">
                <Card.Title>Consumption Report by Medicine</Card.Title>
                <Card.Text>View medicine consumption analytics.</Card.Text>
                <Button onClick={openMedicineModule}>Open</Button>
              </Card>
            </Col>

            <Col md={6}>
              <Card className="shadow-sm text-center p-3">
                <Card.Title>Consumption Report by Patient</Card.Title>
                <Card.Text>View analytics based on patient demographics.</Card.Text>
                <Button onClick={openPatientModule}>Open</Button>
              </Card>
            </Col>
          </Row>
        )}

        {/* MEDICINE REPORT PAGE ───────────────────────────────────────── */}
        {page === "medicine" && (
          <div className="mt-3">
            <h4 className="mb-3">Consumption Report by Medicine</h4>

            {apiEnabled && <VIPDataView currentUser={currentUser} />}

            {!apiEnabled && manualEnabled && (
              <VIPManualAnalytics currentUser={currentUser} />
            )}

            {!apiEnabled && !manualEnabled && (
              <Alert variant="warning">
                No data source enabled. Contact your System Administrator.
              </Alert>
            )}
          </div>
        )}

        {/* PATIENT REPORT PAGE ───────────────────────────────────────── */}
        {page === "patient" && (
          <div className="mt-3">
            <h4 className="mb-3">Consumption Report by Patient</h4>

            {!apiEnabled && manualEnabled && (
              <VIPPatientAnalytics currentUser={currentUser} />
            )}

            {apiEnabled && (
              <Alert variant="warning">
                API-based patient analytics is not yet supported.
              </Alert>
            )}

            {!apiEnabled && !manualEnabled && (
              <Alert variant="warning">
                No data source enabled. Contact your System Administrator.
              </Alert>
            )}
          </div>
        )}
      </Container>
    </>
  );
};

export default VIPDashboard;
